// extracted by mini-css-extract-plugin
module.exports = {"body":"ImagesAddShop_body__jWJY-"};